import useMedia from './useMedia';
import { mediaQueries } from 'helpers/mediaQueries';

export const useIsLargeDevice = () => useMedia(mediaQueries.bpMin1441);
